$ = require 'jquery'
h = require './helpers'
Checkbox = require './../components/checkbox'
auth = require './../components/auth'
router = require './../components/router'

images_url = '//www.tourtrans.ru/js/online-styles/new/'
backend_url = '//admin.tourtrans.ru';

#
# Шаблон TTV_online_design_a.jpg
#
# Список панелей:
# #ctl00_generalContent_UpdatePanel5 - корзина
# #ctl00_generalContent_UpdatePanel7 - информация о туристах

class SimpleBasket
  elements: ->
    this.$submitButton = $('#ctl00_generalContent_SubmitOrderButton')
    # onclick="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions("ctl00$generalContent$SubmitOrderButton", "", true, "", "", false, false))"

  getSubmitButton: ->
    $('#ctl00_generalContent_SubmitOrderButton')

  constructor: ->
    @priceKey = h.getUrlVariable('priceKey')
#    @priceKey = 25834488

  test: ->
    setTimeout ->
      $('.txtLastName input').val 'TestLastname'
      $('.txtFirstName input').val 'TestFirstname'
      $('.txtLastNameRus input').val 'ТестоваяФамилия'
      $('.txtFirstNameRus input').val 'ТестовоеИмя'
      $('.txtPatronymicRus input').val 'ТестовоеОтчество'

      $('.txtBirthPlace input').val 'Москва'
      $('.txtEmail input').val 'test@test.test'
      $('.txtPhone input').val '+79991230101'

      $('.sdtBirthDate input').eq(0).val '11'
      $('.sdtBirthDate input').eq(1).val '11'
      $('.sdtBirthDate input').eq(2).val '1991'

      $('.sdtPassportDateEnd input').eq(0).val '11'
      $('.sdtPassportDateEnd input').eq(1).val '11'
      $('.sdtPassportDateEnd input').eq(2).val '2026'

      $('.pPassportRus input').eq(0).val '4507'
      $('.pPassportRus input').eq(1).val '123321'
      $('.pPassport input').eq(0).val '12345'
      $('.pPassport input').eq(1).val '321123'

      $('.ddlSex select').val '0,0'
    , 500


  applyStyles: ->
    test = router.test()
    if test
      @test()
#    return

    console.log 'Применяю стили SimpleBasket'
    @elements()

    $form = $('#aspnetForm')
#    $form.submit ->
#      console.log 'submit'
##      $('body').attr('id', 'observer')
#      Observer = require './../components/observer'
#      #ctl00_generalContent_UpdateProgress1
#      # aria-hidden
#      # type : attributes
##      observer = new Observer('observer', 'all', (mutation)->
##        console.log 'mutation', mutation
##      )
#      observer = new Observer('ctl00_generalContent_UpdateProgress1', 'aria-hidden', (mutation)->
#        console.log 'mutation', mutation
#        if mutation.oldValue == "false"
#          console.log 'Прячу лоадер'
#        if mutation.oldValue == "true"
#          console.log 'Показываю лоадер'
#      )

#    $('body').addClass('simple_basket')

    $('#ctl00_generalContent_lbPageTitle').closest('table').attr('cellspacing', 0)
    # h1

    # Блок "Бронирование"
    h.h1('Бронирование', 'h1-booking').appendTo $form
    [$booking, this.$bookingContent] = h.rowN(true, 'booking-content')
    $booking.appendTo $form
    @booking()

    # Блок "Услуги"
    h.h1('Услуги', 'h1-services').appendTo $form
    [$services, this.$servicesContent] = h.rowN(true, 'services-content')
    $services.appendTo $form
    @services()

    # Блок "Авиаперелет"
    if $('#ctl00_generalContent_DgFlights').length
      [$avia, $wrapper] = h.rowN(true, 'avia-content')
      $avia.appendTo $form

      $cargoBtn = $('<a class="cargo-btn pull-right"><img src="' + images_url + '/icon_cargo.svg"><span>Условия провоза багажа</span></a>').appendTo $wrapper
      $cargoBtn.click (e) =>
        airlineCode = null
        txt = $('#ctl00_generalContent_DgFlights_ctl03_DdlVariants option[selected]').text()
        tmp = txt.split ' '
        if tmp and tmp[0]
          airlineCode = tmp[0]
        if airlineCode
          @getAirline(airlineCode)

      $wrapper.append $('<h2>Авиаперелет</h2>')
      $wrapper.append $('#ctl00_generalContent_UpdatePanel4')
#      $wrapper.append $('#ctl00_generalContent_DgFlights')
      $avia.find('td:first-child').each (i,e) ->
        if i == 0
          return
        day = $(e).text().replace(/\s/g, '')
        day = 'День ' + day + '-й'
        console.log 'day', day
        $(e).text(day)

    # Блок "Дополнительные услуги"
    dop = @getDop()

    if dop != ''
      [$dop, $wrapper] = h.rowN(true, 'dop-content')
      $dop.appendTo $form

      $wrapper.append $('<h2>Дополнительные услуги</h2>')
      $wrapper.append dop

#      deadline = $('#ctl00_generalContent_VisaDeadLineDates_lblRushDate').text() # срочные
      deadline = $('#ctl00_generalContent_VisaDeadLineDates_lblNormalDate').text() # обычные
      $wrapper.append('<div class="excursion-notice"><p>Экскурсии по туру доступны в шаге 4, на следующем экране после оформления туристов. <br> Выбрать и забронировать место в автобусе - в шаге 6, после оформления туристов и выбора экскурсий.</p><p><b>Рекомендованный срок подачи документов на визу ' + deadline + '</b></p></div>')

    # Блок "Информация о туристах"
    h.h1('Информация о туристах', 'h1-tourists').appendTo $form
    $row = h.row(true, 'tourists-content')
    $form.append $row
    this.$touristsContent = $row.find '.wrapper'
    @tourists()

    $('#ctl00_generalContent_upnButtons').appendTo $form

    [$submit, $wrapper] = h.rowN(true, 'submit-content')
    $submit.appendTo $form

    $submitBtn = $('<input type="submit" class="btn large btn_submit" value="Бронировать">')
    if not auth.logged()
      $submitBtn.attr('disabled', true)
      $span = $ '<div>Вы не авторизованы. Для продолжения бронирования <a href="javascript: window.scrollTo(0,0);">авторизуйтесь</a>. Введенные данные сохранятся.<br><br><br></div>'
      $span.appendTo $wrapper

    $agreementModal = false
    if router.site() == 'personal'
      $agreementModal = $('#ctl00_generalContent_pnAgreement')
      if $agreementModal
        $form.append $agreementModal
        $agreementModal.hide()
        $agreementAccept = $('#ctl00_generalContent_btnOkAgreement')
        $agreementAccept.on 'click', (e) =>
          e.preventDefault()
          $agreementModal.hide()
          @getSubmitButton().click()

    $submitBtn.appendTo $wrapper
    $(document).off 'click.submit'
    $(document).on 'click.submit', '.btn_submit', (e) =>
      e.preventDefault()
      if $agreementModal
        $agreementModal.show()
      else
        @getSubmitButton().click()

    useful_info = require './../html/useful_info.html'
    if router.site() == 'personal'
      useful_info = require './../html/useful_info_personal.html'

    $form.append $(useful_info)

  getAirline: (airlineCode) ->
    $.getJSON(backend_url + "/index.php?r=tours/GetAirLine&code=" + airlineCode + "&jsoncallback=?", (data) ->
      if $('#baggageConditionsInfo').length == 0
        $('<div/>', {style: 'display: none'}).appendTo($('body')).append('<div id="baggageConditionsInfo"></div>')
      $('#baggageConditionsInfo').html(data.airline.baggage_conditions)

      $.fancybox.open([
        {
          href: '#baggageConditionsInfo',
          closeBtn: true
        }
      ], {
        padding : 20,

      })
#      if data.airline.logo
#        $('.flightImg img').show().attr('src', '//www.tourtrans.ru/' + data.airline.logo)
#      else
#        $('.flightImg img').hide()
    )

  services: ->
#    $('#ctl00_generalContent_lbAccmdSelect').closest('table').before()

    # удаляем лишние пененосы строк
#    $('.h1-services').prevAll('br').remove()

    #h2
#    $('.h1-services').parent().after(h.h2('Состав Вашего заказа', 'h2-cart'))
    this.$servicesContent.append h.h2('Состав Вашего заказа', 'h2-cart')
    @addTouristsBtn()
    @moveCart()
    @cart()

  observe: (mutation)->
    console.log 'something changed (observed)'

    console.log('Проверяю ошибки в заполнении полей')
    if ($('span').filter -> $(this).text() == 'x' && $(this).is(':visible')).length > 0 and mutation.oldValue == 'false'
      alert('Заполните все обязательные поля')

    @booking()
    @moveCart()
    @tourists()
    @replaceDopTable()


  replaceDopTable: ->
    $old = $('.dop-table')
    dop = @getDop()
    if dop != ''
      $old.replaceWith dop

  getDop: ->
    unless $('#ctl00_generalContent_lbTourPriceChangedText').length
      return ''
    lines = $('#ctl00_generalContent_lbTourPriceChangedText').html().split('<br>')
    reg = /(.+)::(.+)\/(.+)\/.*\((.+)\)/i;
    $table = $ '<table></table>',
      class: 'dop-table'
    $('<thead><tr><th>Класс</th><th>Страна</th><th>Услуга</th><th>Доп. описание</th><th>Чел.</th><th>Цена</th><th>Валюта</th></tr></thead>').appendTo $table
    $tableBody = $('<tbody></tbody>').appendTo $table
    pplCount = $('#ctl00_generalContent_lbOrderInfo').html().split(' ')[2];
    for line in lines
      if line
        r = line.match reg
        if r
          if r[2]
            names = r[2].split '/'
            if names[1]
              r[2] = names[1]
            else
              r[2] = ''
            price = r[4].match(/([-]*\d+)(\D+)/i);
            console.log 'r[4]', r[4], 'price', price
            name = r[2]
            unless name
              name = r[3]
              r[3] = ''
          cur = h.replace_currency(price[2])
          $tr = $ "<tr><td>#{r[1]}</td><td>#{names[0]}</td><td>#{name}</td><td>#{r[3]}</td><td>#{pplCount}</td><td>#{price[1]}</td><td>#{cur}</td></tr>"
          $tableBody.append($tr)
        else
          l = line.trim();
#          if line.length
#            price = arr[i].match(/РЎС‚РѕРёРјРѕСЃС‚СЊ С‚СѓСЂР° СѓРІРµР»РёС‡РµРЅР° РЅР° (\d+)(\D+)/i)
#            if (price && price[1])
#              servTable.children('tbody').last().append('<tr class="TourPriceChangedTextFooter"><td colspan=3 class="fullPrice"><strong>Р?С‚РѕРіРѕ РґРѕРїРѕР»РЅРёС‚РµР»СЊРЅС‹С… СѓСЃР»СѓРі:</strong></td><td><strong>' + price[1] + '</strong></td><td><strong>' + price[2] + '</strong></td></tr>')
#            else
#              spanStr += '<div>' + line + '</div>'



    $('#ctl00_generalContent_lbTourPriceChangedText')
    $table

  addTouristsBtn: ->
    $addTouristsBtn = $('<div class="btn large"><img src="' + images_url + 'icon_add_tourists.svg">Добавить туристов</div>')
    $('.h2-cart').append $addTouristsBtn
    $addTouristsBtn.click ->
      console.log 'add tourists click'
      $.fancybox.open([
        {
          href: '#ctl00_generalContent_UpdatePanel2',
          closeBtn: true,
        }
      ], {
        padding : 20,
        width: 590,

      })

  moveCart: ->
    # перенесено в стили
    #$('#ctl00_generalContent_lbOrderContent').hide() # Прячем старую надпись 'Состав Вашего заказа'

    $('.h2-cart').after $('#ctl00_generalContent_UpdatePanel5')
    # Менякм обозначение валюты
    $('#ctl00_generalContent_ShoppingCart tr').each (i, e) ->
      $td = $(e).find('td').eq(2)
      cur = $td.text()
      $td.html(h.replace_currency(cur))

  booking: ->
    $cont = $('#ctl00_generalContent_UpdatePanel6')
    this.$bookingContent.append($cont)

    $block = $ '<div/>',
      class: 'booking-1'
    $block.prependTo $cont
    $name = $('<div class="booking-tour-name-block"><div class="image-container"><img src="' + images_url + 'icon_map.svg"></div><h3>Тур:</h3></div>')
    $block.append($name)
    $name.append($('#ctl00_generalContent_UpdatePanel6 #ctl00_generalContent_TourNameLabel'))

    $price = $('<div class="booking-price-block"><img src="' + images_url + 'icon_wallet.svg"><div>Стоимость тура: <span class="price"></span></div><div>К оплате: <span class="pay"></span></div></div>')
    $block.append($price)
    $recalcBtn = $('#ctl00_generalContent_btnRecalculate')
    $('.booking-price-block').append $recalcBtn

    payPrice = @getPayPrice()
    payPrice = h.replace_currency(payPrice)
    $('.pay').html payPrice

    orderPrice = @getOrderPrice()
    orderPrice = h.replace_currency(orderPrice)
    $('.price').html orderPrice

    $('.frontPanel').before('<table class="sb_services_condition_table tourdate_table"><tr><th></th><th></th><th></th><th></th><th></th><th></th></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td></tr></table>');
    $('#ctl00_generalContent_LbTitle21').appendTo($('.sb_services_condition_table th:first-child'));
    $('#ctl00_generalContent_TourDatesLabel').appendTo($('.sb_services_condition_table td:first-child'));

    $('#ctl00_generalContent_LbTitle3').appendTo($('.sb_services_condition_table th:nth-child(2)'));
    $('#ctl00_generalContent_HotelNameLabel').appendTo($('.sb_services_condition_table td:nth-child(2)'));

    $('#ctl00_generalContent_LbTitle4').appendTo($('.sb_services_condition_table th:nth-child(3)'));
    $('#ctl00_generalContent_PansionNameLabel').appendTo($('.sb_services_condition_table td:nth-child(3)'));

    $('#ctl00_generalContent_LbTitle5').appendTo($('.sb_services_condition_table th:nth-child(4)'));
    #    $('#ctl00_generalContent_TxtDuration').siblings().andSelf().wrapAll('<span id="ctl00_generalContent_Duration_wrap" />');
    $('#ctl00_generalContent_Duration_wrap, #ctl00_generalContent_DaysLabel').appendTo($('.sb_services_condition_table td:nth-child(4)'));

    $('#ctl00_generalContent_QuotesDataGrid_ctl01_LbTitle2').html('Наличие мест').appendTo($('.sb_services_condition_table th:nth-child(5)'));
    $('#ctl00_generalContent_QuotesDataGrid_ctl02_HotelQuoteLabel').appendTo($('.sb_services_condition_table td:nth-child(5)'));

    $('.sb_services_condition_table').after('<a class="important">важная информация</a>')

    $('.important').click ->
      $.fancybox.open([{
        href: '#ctl00_generalContent_upTourInfo',
        closeBtn: true
      }], {
        padding: 20
      })
      return false

    @snapPrices()

  snapPrices: ->
    $block = $('.booking-price-block')
    offset_top = $block.offset().top
    $(window).resize ->
      $block = $('.booking-price-block')
      $block.css
        right: $block.closest('.wrapper').offset().left

    $(window).scroll ->
#      console.log 'scroll event'
      $block = $('.booking-price-block')
      if $block.length
        $block.css
          right: $block.closest('.wrapper').offset().left

        scroll_top = $(document).scrollTop()
        #      console.log 'ot', offset_top, 'st', scroll_top
        if not $block.hasClass('fixed') and offset_top < scroll_top
  #        console.log 'add fixed'
          $block.addClass('fixed')
        if $block.hasClass('fixed') and offset_top >= scroll_top
  #        console.log 'rm fixed'
          $block.removeClass('fixed')

  cart: ->
    $('#ctl00_generalContent_UpdatePanel2').closest('tr').hide()
    $included = $('<table class="table-included"><tr><td><span class="h3">В состав тура включено:</span></td><td><ul class="included"></ul></td></tr></table>')
    $('#ctl00_generalContent_ShoppingCart').after($included)
    @getIncludedServices (services) ->
      console.log 'В состав тура включено:', services
      if services.length == 0
        $li = $('<li></li>').html('<b>Список пуст</b>')
        $('.included').append($li)
      for service in services
        $li = $('<li></li>').html(service)
        $('.included').append($li)

  tourists: ->

#    $('#ctl00_generalContent_UpdatePanel5').after($('.h1-tourists')) #TODO: создавать сразу на месте
#    $('.h1-tourists').after($('#ctl00_generalContent_UpdatePanel7'))
    $cont = $('#ctl00_generalContent_UpdatePanel7')
    this.$touristsContent.append $cont

    $cont.find('table').hide() # Таблица со списком туристов
    $cont.after($('#ctl00_generalContent_upNotes'))

    $('#ctl00_generalContent_PnNotes').prepend($('#ctl00_generalContent_revNotes')) # Сообщение об ошиибке?
    unless $('.h2-notes').length
      $('#ctl00_generalContent_PnNotes').prepend($('#ctl00_generalContent_TxtAdditionalInformation'))
      $('#ctl00_generalContent_PnNotes').prepend(h.h2('Примечание к заявке', 'h2-notes'))
    $('#ctl00_generalContent_PnNotes table').hide() # Надпись "Примечание к заявке"
    @tourists_list()

  tourists_list: ->
    $cont = $('<div class="tourists-list"></div>')
    $cont.prependTo($('#ctl00_generalContent_UpdatePanel7'))

    $table = $('#ctl00_generalContent_touristData_dgTourists')
    $rows = $table.find('tr')
    headers = {}
    $rows.each (i, e) ->
      if i == 0
        $cols = $(e).find('td')
        $cols.each (index, elem) ->
          headers[index] = $(elem).html().replace('<br>', ' ')
        console.log 'headers', headers
      else
        $tourist = $ '<div/>',
          class: 'tourist-item'
        $cont.append($tourist)

        $data = $ '<div/>',
          class: 'tourist-data'
        $tourist.append(h.h2('<img src="' + images_url + 'icon_tourist.svg">Турист ' + i, 'h2-tourist'))
        $tourist.append $data

        $cols = $(e).find('td')
        $cols.each (index, elem) ->
          header = headers[index]
          content = $(elem).children()
          field_class = 'none'
          $input = $(elem).find('select, input')
          if $input
            input_name = $input.attr('name')
            if input_name
              tmp = input_name.split('$')
              field_class = tmp[tmp.length - 1]
              if field_class == 'txtDay'
                field_class += ' ' + tmp[tmp.length - 2]
              if field_class == 'txtPassportSeries'
                field_class += ' ' + tmp[tmp.length - 2]
          if header.match(/^Доплаты/)
            field_class += ' ' + 'additional_payments'
          if header.match(/^Виза/)
            field_class += ' ' + 'visa'
          if header.match(/^Скидки/)
            field_class += ' ' + 'discounts'
          if header.match(/^Групповой трансфер/)
            field_class += ' ' + 'transfer'
          if header.match(/^Страховка/)
            field_class += ' ' + 'insurance'
          $row = $('<div class="' + field_class + '"><label>' + header + '</label></div>')

          $row.append(content)
          $data.append($row)
          # console.log(field_class, header)

        $common = $ '<div/>',
          class: 'block-common'
        $data.append($common)

        $passports = $ '<div/>',
          class: 'block-passports'
        $data.append($passports)

        $more = $ '<div/>',
          class: 'block-more'
        $data.append($more)

        $common.append('<h3>Введите данные туриста:</h3>')
        $common.append('<span class="red"><b>ВНИМАНИЕ!</b> Внесение недостоверных паспортных данных может привести к ДОПОЛНИТЕЛЬНЫМ финансовым затратам (за переписку ж/д, авиабилетов и т.д.), которые возлагаются на агентство, указавшее неверные данные.</span>')

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $common.append($columns)

        $data.find('.txtLastNameRus').appendTo($left)
        $data.find('.txtFirstNameRus').appendTo($left)
        $data.find('.txtPatronymicRus').appendTo($left)
        $data.find('.txtLastName').appendTo($left)
        $data.find('.txtFirstName').appendTo($left)
        $data.find('.txtFirstName').appendTo($left)

        $birth = $data.find('.sdtBirthDate')
        $birthLabel = $birth.appendTo($right).find('label')
        $font = $birth.find('font')
        if $font
          $label = $('<label>День рождения</label>')
          $label.append($font)
          $birthLabel.replaceWith($label)
        $ddlSex = $data.find('.ddlSex')
        $ddlSex.appendTo($right)

        $birthDay = $birth.find('input:eq(0)')
        $birthMonth = $birth.find('input:eq(1)')
        $birthYear = $birth.find('input:eq(2)')
        $ddlSexSelect = $ddlSex.find('select')

        console.log 'day', $birthDay
        console.log 'month', $birthMonth
        console.log 'year', $birthYear
        console.log 'sex', $ddlSexSelect

        $sex = $ '
          <div class="sex">
            <label>Пол<font color="red">*</font></label>
            <div class="radio-group">
              <input id="male' + i + '" name="sex' + i + '" type="radio" value="0">
              <label for="male' + i + '">Мужской</label>
              <input id="female' + i + '" name="sex' + i + '" type="radio" value="1">
              <label for="female' + i + '">Женский</label>
            </div>
          </div>
        '
        $sex.appendTo($right)
        qp = router.queryParams()
        date = new Date(qp.date)
#        console.log("Дата тура: ", date)

        updateSex = () ->
          # calc age
          birthDate = new Date($birthYear.val(), $birthMonth.val() - 1, $birthDay.val())
          age = date - birthDate
          age = age / (1000*60*60*24*366) # на всякий случай посчитаем как 366
#          console.log "День рождения: ", birthDate, "На дату тура туристу будет #{Math.floor(age)} лет", age
          sex = $sex.find('input:checked').val()
          if age > 18
            $ddlSexSelect.val("#{sex},#{sex}")
          else if age > 2
            $ddlSexSelect.val("2,#{sex}")
          else
            $ddlSexSelect.val("3,#{sex}")

        $sex.find('input').change(updateSex)
        $birthDay.on('input', updateSex)
        $birthMonth.on('input', updateSex)
        $birthYear.on('input', updateSex)


        $data.find('.txtBirthPlace').appendTo($right)
        $data.find('.txtEmail').appendTo($right)
        $data.find('.txtPhone').appendTo($right)


        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $passports.append($columns)

        $data.find('.pPassportRus').appendTo($left)
        $data.find('.ddlCitizenship').appendTo($left)

        $data.find('.pPassport').appendTo($right)
        $data.find('.sdtPassportDateEnd').appendTo($right)
        $data.find('.txtPassportByWhomRus').appendTo($right)
        $data.find('.sdtPassportDateRus').appendTo($right)


        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $more.append('<h3>Введите услуги на туриста:</h3>')
        $more.append($columns)

        $data.find('.visa').appendTo $left # Виза
        $discounts = $data.find('.discounts') # Скидки
        $discounts.appendTo $left
        $default = $discounts.find('option:contains("Без скидки постоянного клиента")')
#        $default = $discounts.find('option[text="Без скидки постоянного клиента"]')
        $select = $discounts.find('select')
        if $default.length
          if not $select.val()
            $default = $default.first()
            $select.val($default.val())
          $discounts.find('option[value=""]').remove()

        # Страховка
        $insurance = $data.find('.insurance')
        if $insurance.length
          console.log '$insurance', $insurance
          $insurance.appendTo $left
          insurance = $insurance.text()
          console.log 'insurance', insurance
          r = insurance.match /\/(.+)\//
          $insurance.find('label').html('<b>Страховка:</b>')
          $insurance.append('<span>' + r[1] + '</span>')

        $data.find('.additional_payments').appendTo $right # Доплаты
        $data.find('.transfer').appendTo $right # Групповой трансфер

        $fields = []
        for i in [0 .. 20]
          if i < 10
            klass = 'ctl0' + i
          else
            klass = 'ctl' + i
          $field = $data.find('.' + klass)
          if $field.length
            unless $field.is('.visa, .discounts, .insurance, .additional_payments, .transfer')
              $fields.push $field

        for $field in $fields
          leftCount = $more.find('.col-1 > div').length
          rightCount = $more.find('.col-2 > div').length
          if leftCount > rightCount
            $field.appendTo $right
          else
            $field.appendTo $left
          $input = $field.find('input[type="checkbox"]')
          $label = $field.find('label')
          if $input.length and $label.length
            new Checkbox($input, $label)
#          $field.find('label').addClass('checkbox-label')

        $applyToAllBtn = $ '<a class="btn large pull-right apply_all">Применить ко всем туристам</a>'
        $applyToAllBtn.click (e) ->
          $m = $(this).closest('.block-more')

          for i in [0..9]
            klass = 'ctl0' + i
            $field = $m.find ".#{klass} select"
            $(".#{klass} select").val $field.val()
            $field = $m.find ".#{klass} input"
            $(".#{klass} input").prop('checked', $field.prop('checked'))
            $(".#{klass} input").val $field.val()
            $(".#{klass} input").change()

#          $visa = $m.find '.visa select'
#          $('.ctl00 select').val $visa.val()
#
#          $discounts = $m.find '.discounts select'
#          $('.ctl01 select').val $discounts.val()
#
#          $dop = $m.find '.additional_payments select'
#          $('.ctl02 select').val $dop.val()

        $more.append($applyToAllBtn)

#      $cols = $(e).find('td')
#      $cols.each (ii, ee) ->
#        console.log $(ee).text()

  getPayPrice: ->
    price = $('#ctl00_generalContent_LbToPay').text()
    currency = $('#ctl00_generalContent_LbRateToPay').text()
    price + currency

  getOrderPrice: ->
    price = $('#ctl00_generalContent_lbOrderPrice').text()
    currency = $('#ctl00_generalContent_lbRate').text()
    price + currency

  getIncludedServices: (cb) ->
    # портировано из старой версии
    $.getJSON backend_url + "/index.php?r=tours/GetAcctypeServices&PriceKey=" + @priceKey + "&fromOnline=1&jsoncallback=?", (data) ->
      lines = []
      for result in data.result
        text = result.Name;

        if ($('#ctl00_generalContent_lbFlightTariffChanged').length && result.Class == 'FlightService')
          continue;

        if (result.Class == 'HotelService' && result.Country != 460 && result.shortName)
          text = result.shortName

        if result.Class == 'HotelService' && result.Country == 460 && result.Name.indexOf('Измайлово') != -1
          text = result.serviceModel.name

        if (result.Class == 'ExcursionService' || result.Class == 'TransferService') && result.shortName
          text = result.shortName

        if result.Class == 'AdditionalService' && result.ServiceClassID == 1504
          continue

        lines.push(text)

      cb(lines)


module.exports = SimpleBasket
